export enum Anrede {
  HERR = "Herr",
  FRAU = "Frau",
  KEINE_ANGABE = "Keine_Angabe",
}
